import React                   from 'react'
import i18n from '../../../i18n';

export default (props) => {
  return (
    <div className="col-sm-12 content-body applications-empty">
      <div className="icon"></div>
      <div className="text">
        <p>
          {i18n.t('application.empty_txt_line_1')}<br />
          {i18n.t('application.empty_txt_line_2')}<br />
          {i18n.t('application.empty_txt_line_3')}
        </p>
      </div>
    </div>
  )
}